import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { LeftButton, RightButton } from 'components';
import { useWindowSize } from 'hooks';
import ReactMultiCarousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

function CustomLeftArrow({ onClick, windowWidth, numberOfCards }) {
  return (
    <LeftButton
      onClick={() => onClick()}
      style={{
        position: 'absolute !important',
        left:
          windowWidth >= 535
            ? '-1.25rem'
            : `calc(50% - (48px + 12px + (${numberOfCards / 2} * 9px) + (${numberOfCards / 2 - 1} * 6px)))`,
        bottom: windowWidth < 535 ? '-3.5rem' : 'initial',
        zIndex: 1
      }}
    />
  );
}

function CustomRightArrow({ onClick, windowWidth, numberOfCards }) {
  return (
    <RightButton
      onClick={() => onClick()}
      style={{
        position: 'absolute !important',
        right:
          windowWidth >= 535
            ? '-1.25rem'
            : `calc(50% - (48px + 12px + (${numberOfCards / 2} * 9px) + (${numberOfCards / 2 - 2} * 6px)))`,
        bottom: windowWidth < 535 ? '-3.5rem' : 'initial',
        zIndex: 1
      }}
    />
  );
}

const MultiColumnCarousel = forwardRef((props, ref) => {
  const { title, cards, backgroundColor, responsive } = props;

  const { windowWidth } = useWindowSize();

  return (
    <Container $backgroundColor={backgroundColor} ref={ref} className={props.className}>
      <h3>{title}</h3>
      <InnerContainer className="fade-in">
        <StyledReactMultiCarousel
          customLeftArrow={
            <CustomLeftArrow windowWidth={windowWidth} numberOfCards={cards.length} />
          }
          customRightArrow={
            <CustomRightArrow windowWidth={windowWidth} numberOfCards={cards.length} />
          }
          responsive={responsive}
          swipeable
          draggable
          showDots={windowWidth < 535}
          ssr
          infinite
          autoPlay
          autoPlaySpeed={4000}
          transitionDuration={500}
          keyBoardControl>
          {cards}
        </StyledReactMultiCarousel>
      </InnerContainer>
    </Container>
  );
});

const Container = styled.section`
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'var(--connolly-grey)'};

  > h3 {
    color: var(--connolly-black);
    font-size: 2rem;
    text-align: center;
  }
`;

const InnerContainer = styled.div`
  margin: 0 auto;
  position: relative;
`;

const StyledReactMultiCarousel = styled(ReactMultiCarousel)`
  margin: 0 auto;

  /* max-width: 67.5rem; */

  /* padding: 0.375rem 0 0 0.625rem; */
  position: static !important;
  width: 100%;

  @media (width >= 380px) {
    padding: 0.375rem 0 0 0.625rem;
  }

  .react-multi-carousel-dot-list {
    bottom: -2.825rem;
  }

  /* ${({ children }) =>
    children.length < 3 &&
    css`
      .react-multi-carousel-track {
        margin: 0 auto !important;
        transform: translate3d(0, 0, 0) !important;
      }
    `} */
`;

export default MultiColumnCarousel;
